import * as _ from 'lodash';
import * as types from './types';
import { FieldEnum } from 'Common/FieldEnum';

const INITIAL_STATE = {
  data: [],
  initialData: [],
  loading: false,
  checkAllChecked: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SITESETUP_CLEAR_ASSIGN_USER_DATA:
      return { ...INITIAL_STATE };

    case types.SITESETUP_CHECKALL_ASSIGN_USER_DATA: {
      const copiedData = _.cloneDeep(state.data);
      let checkAllChecked = false;
      const { currentRows, checkAll } = action.payload;
      copiedData.forEach(x => {
        const foundRow = _.find(currentRows, {
          UserName: x.UserName,
        });
        if (foundRow) {
          x[FieldEnum.Allowed] !== checkAll &&
            x[FieldEnum.AccessibleFunctions] &&
            x[FieldEnum.AccessibleFunctions].length &&
            _.forEach(x[FieldEnum.AccessibleFunctions], menuAccess => {
              menuAccess[FieldEnum.IsPageAccessible] = checkAll;
            });

          x[FieldEnum.Allowed] = checkAll;
          checkAllChecked = checkAll;
        }
      });

      return {
        ...state,
        data: copiedData,
        checkAllChecked,
      };
    }

    case types.SITESETUP_SET_ASSIGN_USER_DATA: {
      const initialData = [];
      const data = _.cloneDeep(action.payload.data.Data);

      data.forEach(item => {
        initialData.push({
          username: item.UserName,
          initialValue: item[FieldEnum.Allowed] === 1,
          AccessibleFunctions: item[FieldEnum.AccessibleFunctions],
          initialIsReadOnly: false,
        });

        item.Allowed = item[FieldEnum.Allowed] === 1;
        item[FieldEnum.IsReadOnly] = !!item[FieldEnum.IsReadOnly];
      });

      return {
        ...state,
        data,
        initialData,
      };
    }

    case types.SITESETUP_UPDATE_ASSIGN_USER_DATA: {
      const copiedData = _.cloneDeep(state.data);
      const { item } = action.payload;
      const user = _.find(copiedData, { UserName: item.UserName });
      let checkAllChecked = false;

      if (!user) {
        return state;
      }
      user[FieldEnum.Allowed] = !item[FieldEnum.Allowed];
      user[FieldEnum.AccessibleFunctions] &&
        user[FieldEnum.AccessibleFunctions].length &&
        _.forEach(user[FieldEnum.AccessibleFunctions], menuAccess => {
          menuAccess[FieldEnum.IsPageAccessible] = user[FieldEnum.Allowed];
        });
      checkAllChecked =
        copiedData.length !== 0 &&
        copiedData.length ===
          _.sumBy(copiedData, user => user[FieldEnum.Allowed]);

      return {
        ...state,
        data: copiedData,
        checkAllChecked,
      };
    }
    case types.SITESETUP_UPDATE_IS_PAGE_ACCESSIBLE: {
      let checkAllChecked = false;
      const copiedStateData = _.cloneDeep(state.data);
      const { currentRows, fieldName, userName, index } = action.payload;
      const userIndex = _.findIndex(copiedStateData, ['UserName', userName]);
      if (userIndex > -1) {
        const userDetail = copiedStateData[userIndex];
        userDetail[FieldEnum.AccessibleFunctions][index][
          fieldName
        ] = !currentRows[fieldName];
        copiedStateData[userIndex] = userDetail;
      }
      checkAllChecked =
        copiedStateData.length !== 0 &&
        copiedStateData.length ===
          _.sumBy(copiedStateData, user => user[FieldEnum.Allowed]);
      return {
        ...state,
        data: copiedStateData,
        checkAllChecked,
      };
    }

    case types.SITESETUP_SET_ASSIGN_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/assignUsers/reducer.js